import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrListPersonFilesPathParameters } from 'api/actions/hr-list-person-files/hr-list-person-files-path-parameters';
import { HrListPersonFilesResponse } from 'api/actions/hr-list-person-files/hr-list-person-files-response';

type HrListPersonFilesQueryParameters = Record<string, any>;

/**
 * The path of the HrListPersonFiles action.
 */
export const hrListPersonFilesActionPath = new SweetPath<keyof HrListPersonFilesPathParameters>(
  '/api/hr/people/{personId}/files',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrListPersonFiles actions.
 */
export default function createHrListPersonFilesAction(axios: AxiosInstance) {
  return function hrListPersonFilesAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrListPersonFilesPathParameters;
    query?: HrListPersonFilesQueryParameters;
  }) {
    const path = hrListPersonFilesActionPath.insert(parameters);

    return axios.request<HrListPersonFilesResponse, HrListPersonFilesResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
